import { createContext } from 'react'

export const DataProviderContext = createContext({
    data: {},
    setData: () => {}
})
